import { apiUrl } from "./config";

export class ApiError extends Error {
  code?: string;
  status: number;
  eventId?: string;
  details?: unknown;

  constructor(message: string, status: number, payload?: { code?: string; eventId?: string; details?: unknown }) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = payload?.code;
    this.eventId = payload?.eventId;
    this.details = payload?.details;
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(apiUrl(path), {
    credentials: "include",
    ...init,
    headers: {
      ...(init?.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...init?.headers,
    },
  });

  const contentType = response.headers.get("content-type") ?? "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await response.json().catch(() => null) : null;

  if (!response.ok) {
    const message =
      payload && typeof payload === "object" && payload && "message" in payload
        ? String((payload as { message: string }).message)
        : `Request failed (${response.status})`;
    throw new ApiError(message, response.status, {
      code: payload && typeof payload === "object" && "code" in payload ? String((payload as { code: string }).code) : undefined,
      eventId:
        payload && typeof payload === "object" && "eventId" in payload
          ? String((payload as { eventId: string }).eventId)
          : undefined,
      details: payload,
    });
  }

  return payload as T;
}
